export { default as Informative } from './Informative';
